import { urlSearchParamsIncludes } from '~/utils-ts';

export const hasTokensInUrl = () =>
  urlSearchParamsIncludes(['accessToken', 'refreshToken']);
